'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Conversation = function (_React$PureComponent) {
  _inherits(Conversation, _React$PureComponent);

  function Conversation() {
    _classCallCheck(this, Conversation);

    return _possibleConstructorReturn(this, (Conversation.__proto__ || Object.getPrototypeOf(Conversation)).apply(this, arguments));
  }

  _createClass(Conversation, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        {
          width: this.props.size,
          height: this.props.size + 8,
          viewBox: '0 0 96 104',
          version: '1.1',
          xmlnsXlink: 'http://www.w3.org/1999/xlink'
        },
        _react2.default.createElement(
          'g',
          {
            transform: 'translate(-16.000000, -12.000000) translate(16.000000, 12.000000)',
            stroke: 'none',
            strokeWidth: 1,
            fill: 'none',
            fillRule: 'evenodd'
          },
          _react2.default.createElement('path', {
            d: 'M96.008 52.59c0 23.334-21.49 42.27-48.01 42.27a53.841 53.841 0 0 1-13.338-1.664l-17.31 9.649a2.58 2.58 0 0 1-3.703-3.019L18.06 85.65C7.017 77.91 0 65.966 0 52.59c0-23.348 21.503-42.27 48.01-42.27 26.508 0 47.998 18.922 47.998 42.27z',
            fill: '#000',
            fillRule: 'nonzero',
            opacity: '0.15'
          }),
          _react2.default.createElement('path', {
            d: 'M96.008 47.417c0 23.335-21.49 42.27-48.01 42.27a53.841 53.841 0 0 1-13.338-1.663l-17.31 9.661a2.58 2.58 0 0 1-3.703-3.018l4.463-14.19C7.07 72.739.052 60.795.052 47.418 0 24.083 21.502 5.16 48.01 5.16c26.507 0 47.997 18.923 47.997 42.257z',
            fill: '#CA2'
          }),
          _react2.default.createElement('path', {
            d: 'M96.008 42.258c0 23.334-21.49 42.27-48.01 42.27a53.84 53.84 0 0 1-13.338-1.664l-17.31 9.649a2.58 2.58 0 0 1-3.703-3.019l4.463-14.189C7.07 67.565.052 55.621.052 42.245 0 18.923 21.502 0 48.01 0c26.507 0 47.997 18.923 47.997 42.258z',
            fill: '#F1C40F'
          }),
          _react2.default.createElement('path', {
            d: 'M48.01 61.735c-8.89.13-16.207-6.963-16.356-15.853a4.308 4.308 0 0 1 8.604 0 7.74 7.74 0 1 0 15.48 0 4.308 4.308 0 0 1 8.603 0c-.149 8.88-7.45 15.968-16.33 15.853m12.06-23.554a4.347 4.347 0 0 1-3.005-1.2 4.037 4.037 0 0 1 0-5.817 4.334 4.334 0 0 1 5.998 0 4.025 4.025 0 0 1 0 5.818 4.347 4.347 0 0 1-3.006 1.2m-24.16 0a4.347 4.347 0 0 1-3.005-1.2 4.037 4.037 0 0 1 0-5.818 4.347 4.347 0 0 1 6.01 0 4.037 4.037 0 0 1 0 5.818 4.347 4.347 0 0 1-3.005 1.2',
            fill: '#FFF'
          }),
          _react2.default.createElement('path', {
            d: 'M87.275 29.539a1.29 1.29 0 0 1-1.212-.864C82.554 18.42 67.192 7.739 53.313 5.882a1.302 1.302 0 0 1 .347-2.58c14.718 2 30.958 13.441 34.828 24.509a1.29 1.29 0 0 1-1.213 1.715v.013z',
            fill: '#FFF',
            fillRule: 'nonzero',
            opacity: '0.5'
          })
        )
      );
    }
  }]);

  return Conversation;
}(_react2.default.PureComponent);

Conversation.defaultProps = {
  size: 64
};

Conversation.propTypes = {
  size: _propTypes2.default.number
};

exports.default = Conversation;